<div [class.form-label]="shouldShowLabel" class="d-flex justify-content-between align-items-center">
  <span *ngIf="shouldShowLabel">
    {{ props.label }}
    <span *ngIf="props.required">*</span>
  </span>

  <a *ngIf="shouldShowCopyLink && canShowCopyLink" href="javascript:void(0)"
    class="text-primary text-decoration-none small mb-1" (click)="copyFromPhoneNumber()" style="font-size: 0.85rem;">
    <i class="fas fa-copy me-1"></i>
    {{ 'Copy from Phone Number' | translate }}
  </a>
</div>

<div class="d-flex form-control p-0"
  [class.is-invalid]="formControl.invalid && (formControl.dirty || formControl.touched)"
  [style.background-color]="isDisabled ? 'var(--bs-secondary-bg)' : null">
  <ng-select data-type="phone" [items]="countries" bindLabel="name" bindValue="dialCode" [clearable]="false"
    [dropdownPosition]="'bottom'" [appendTo]="props['appendToBody'] ? 'body' : ''" [(ngModel)]="selectedDialCode"
    (change)="onDialCodeChange()" class="w-auto phone-input ms-2" [disabled]="isDisabled">

    <ng-template ng-option-tmp let-item="item">
      <img [src]="item.flag" class="me-1 flag-icon" alt="{{ item.name }} flag" />
      {{ item.name }} ({{ item.dialCode }})
    </ng-template>

    <ng-template ng-label-tmp let-item="item">
      <img [src]="item.flag" class="me-1 flag-icon" alt="{{ item.dialCode }} flag" />
      {{ item.dialCode }}
    </ng-template>

  </ng-select>

  <input type="tel" class="form-control input-phone" [formControl]="numberControl" (input)="updateValue()"
    placeholder="{{ 'Phone number' | translate }}" (blur)="formControl.markAsTouched()" />
</div>